<template>
  <v-col>
    <div class="text-center">
      <strong>Quick Mail</strong>
    </div>
    <form @submit.prevent="send">
      <v-col>
        <v-text-field
          v-model="mail.email"
          label="Email"
          :error-messages="errors.getMessage('email')"
        />

        <v-text-field
          v-model="mail.subject"
          label="Subject"
          :error-messages="errors.getMessage('subject')"
        />

        <wysiwyg
          v-model="mail.message"
          class="mt-2"
        />
        <p class="error--text">
          {{ errors.getMessage("message") }}
        </p>

        <v-btn
          color="info"
          type="submit"
        >
          Send Mail
        </v-btn>
      </v-col>
    </form>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      mail: {
        email: "",
        message: "",
        subject: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      errors: "validation/pull",
    }),
  },
  mounted() {
    if (this.$route.params.email) {
      this.mail.email = this.$route.params.email;
    }
  },
  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),
    send() {
      window.axios.post("/send-mail", this.mail).then((response) => {
        this.feedback(response.data.message);
        this.mail.subject = null;
        this.mail.message = null;
      });
    },
  },
};
</script>
